// NOTE: If you're seeing the error "useRouteError must be used within a data router",
// make sure your app is wrapped using `createBrowserRouter` and `RouterProvider`.
// This component itself is not the problem — it will work correctly if the app uses a Data Router.




import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ThemeToggle from "./ThemeToggle"; // dark / Light Mode 
import "./Navbar.css";

// Icons
import iconHome from '../Img/Nav_Icons/home.svg';
import iconImmersive from '../Img/Nav_Icons/vrUser.svg';
import iconApps from '../Img/Nav_Icons/launcher.svg';
import iconMovingImage from '../Img/Nav_Icons/film.svg';
import iconPhotography from '../Img/Nav_Icons/photography.svg';
import iconPublications from '../Img/Nav_Icons/article.svg';
import iconResearch from '../Img/Nav_Icons/research.svg';
import iconContact from '../Img/Nav_Icons/email.svg';


const Navbar = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const navigate = useNavigate();

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.site_menu')) {
        setActiveIndex(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  // site_menu__subitem_1: "Home",
  const menuItems = [
    {
      icon: iconHome,
      alt: "Home",
      path: "/",
      id: "home",
      subItems: [
        // { id: "home", title: "Home", path: "/" }, [] // <--- empty array links to the home icon ans not a dropdown
      ]
    },
    {
      icon: iconImmersive,
      alt: "Immersive",
      site_menu__subitem_1: "Immersive",
      path: "/immersive",
      id: "immersive",
      subItems: [
        { id: "Haze", title: "Haze", path: "/immersive/Haze" },
        { id: "VirtualPavilion", title: "Virtual Pavilion", path: "/Immersive/VirtualPavilion" },
        { id: "breathTaking", title: "BreathTaking", path: "/immersive/BreathTaking" },
        { id: "watching", title: "Watching", path: "/immersive/watching" },
        { id: "ImmaterialSpaces", title: "Immaterial Spaces", path: "/immersive/ImmaterialSpaces" },
        // { id: "BreathtakingVisitorBook", title: "BreathTaking Visitor Book", path: "/immersive/BreathtakingVisitorBook" }
      ]
    },
    {
      icon: iconApps,
      alt: "Apps",
      site_menu__subitem_1: "Apps",
      path: "/apps",
      id: "apps",
      subItems: [
        { id: "Street-Quest", title: "Street Quest®", path: "/apps/StreetQuest" },
        { id: "street story", title: "Street Story™", path: "/apps/StreetStory" },
        { id: "xrh", title: "XrH", path: "/apps/Xrh" },
        { id: "matterbot", title: "matterBot", path: "/apps/MatterBot" },
        { id: "AirTime", title: "airTime", path: "/apps/AirTime" }
      ]
    },
        {
      icon: iconMovingImage,
      alt: "Moving Image",
      site_menu__subitem_1: "Moving Image",
      path: "/moving-image",
      id: "moving-image",
      subItems: [
        { id: "thomas-highflyer", title: "Thomas Highflyer", path: "/moving-image/ThomasHighflyer" },
        { id: "in-place-of-silence", title: "In place of Silence", path: "/moving-image/InPlaceOfSilence" },
        { id: "of-the-sea", title: "of the sea", path: "/moving-image/OfTheSea" }
      ]
    },
    {
      icon: iconPhotography,
      alt: "Photography",
      site_menu__subitem_1: "Photography",
      path: "/photography",
      id: "photography",
      subItems: [    
        { id: "unknown-portrait", title: "Unknown Portrait", path: "/photography/UnknownPortrait" },
        { id: "studentLife", title: "Students Life", path: "/photography/StudentLife" },
        { id: "student", title: "Student", path: "/photography/Student" },
        { id: "pelham", title: "Pelham", path: "/photography/Pelham" },    
        { id: "museum", title: "Museum", path: "/photography/Museum" },
        { id: "KapanoFC", title: "KapanoFC", path: "/publications/KapanoFC" },
            // { id: "?", title: "?", path: "/photography/?" },
      ]
    },
    {
      icon: iconPublications,
      alt: "Publications",
      site_menu__subitem_1: "Publications",
      path: "/publications",
      id: "publications",
      subItems: [
        { id: "Mapping Our Digital World", title: "Creating with Technology", path: "/publications/CreatingWithTechnology" },
        { id: "geo-visual-stories", title: "Geo-Visual Stories", path: "/publications/GeoVisualStories" },
        { id: "space-cowgirl", title: "Space Cowgirl", path: "/publications/SpaceCowGirl" },
        { id: "Legacies-Slavery", title: "Legacies Of British Slavery", path: "/publications/LegaciesOfBritishSlavery" },
        { id: "fashion-cities-africa", title: "Fashion Cities Africa", path: "/publications/FashionCitiesAfrica" },
        { id: "photoworks-biennial", title: "PhotoWorks Biennial", path: "/publications/PhotoworksBiennial" },
        { id: "carnival", title: "Carnival", path: "/publications/Carnival" },
        { id: "PositiveHairDay", title: "Positive Hair Day", path: "/publications/PositiveHairDay" },
        { id: "jubilee", title: "Jubilee", path: "/publications/Jubilee" },
       
        // { id: "marathan", title: "Marathan", path: "/publications/Marathan" },
      ]
    },
    

// password protect phd Journal
    {
      icon: iconResearch,
      alt: "Research",
      site_menu__subitem_1: "Research",
      path: "/research",
      id: "research",
      subItems: [
        { id: "PhD journal", title: "Journal", path: "/research/journal" },
        // { id: "Guidedwalks", title: "Guidedwalks", path: "/research/Guidedwalks" },
        // { id: "work-in-progress", title: "Work in Progress", path: "/research/WorkInProgress" },
        // { id: "research-proposal", title: "Research Proposals", path: "/research/Proposals" },
        // { id: "conference-papers", title: "Conference Papers",  path: "/research/ConferencePapers" },
        
      ]
    },
    // {
    //   icon: iconContact,
    //   alt: "Message me",
    //   path: "/contact",
    //   id: "contact",
    //   subItems: [
    //     { id: "contact", title: "message me ", path: "/contact/contact" },
    //   ]
    // }
  ];

  const handleIconInteraction = (index, path) => {
    // Toggle submenu if it has subitems
    if (menuItems[index].subItems.length > 0) {
      setActiveIndex(activeIndex === index ? null : index);
    } else {
      // Navigate immediately if no subitems
      navigate(path);
      setActiveIndex(null);
    }
  };

  const handleSubItemClick = () => {
    setActiveIndex(null);
  };
  
  return (
    <nav className="site_menu">
      {menuItems.map((item, index) => (
        <div
          key={index}
          className={`site_menu__item ${activeIndex === index ? 'submenu-active' : ''}`}
          
          onMouseEnter={() => setHoverIndex(index)}
          onMouseLeave={() => setHoverIndex(null)}
        
        // data-tooltip={item.alt} // hover over text passes the 'alt' text for the tooltip
        
        >
          <div 
            className="site_menu__icon-container"
            onClick={() => handleIconInteraction(index, item.path)}
          >
            <img 
              src={item.icon} 
              alt={item.alt} 
              className={`site_menu__icon ${hoverIndex === index ? 'hovered' : ''}`}
            />
          </div>
          
          {/* Submenu appears when active */}
          {activeIndex === index && (
            <div className="site_menu__submenu">
              {item.site_menu__subitem_1 && (
                <div className="site_menu__subitem-1">
                  {item.site_menu__subitem_1}
                </div>
              )}
              {item.subItems.map((subItem, subIndex) => (
                <Link
                  key={subIndex}
                  to={subItem.path}
                  className="site_menu__subitem"
                  tabIndex="0"
                  onClick={handleSubItemClick}
                >
                  {subItem.title}
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
        {/* Theme Toggle Component */}
      <ThemeToggle />
    </nav>
  );
};

export default Navbar;